import { call, takeLatest } from "redux-saga/effects";
import { API_URL, SAGA_ACTIONS, sagaFunction } from "../_config";
import { CallApi } from "./api/callApi";

function* getJobModerationList(action: any): any {
  yield call(sagaFunction, action, CallApi.GET, API_URL.JOBS.LIST, action.payload, true);
}

function* bulkUpdateJobStatus(action: any): any {
  yield call(sagaFunction, action, CallApi.POST, API_URL.JOBS.BULK_STATUS, action.payload, true);
}

function* getCompanyJobs(action: any): any {
  const { companyId, ...params } = action.payload || {};
  const url = API_URL.JOBS.COMPANY_JOBS(companyId);
  yield call(sagaFunction, { ...action, payload: params }, CallApi.GET, url, params, true);
}

export default function* adminJobsSaga() {
  yield takeLatest(SAGA_ACTIONS.ADMIN.JOBS.LIST, getJobModerationList);
  yield takeLatest(SAGA_ACTIONS.ADMIN.JOBS.BULK_STATUS, bulkUpdateJobStatus);
  yield takeLatest(SAGA_ACTIONS.ADMIN.JOBS.COMPANY_JOBS, getCompanyJobs);
}
